import apiClient from '../api';
import type { LoginPayload, StudentLoginPayload, LoginResponse, ProfileResponse } from './types';

export const authService = {
    login: (payload: LoginPayload) =>
        apiClient.post<LoginResponse>('/auth/login', payload),

    studentLogin: (payload: StudentLoginPayload) =>
        apiClient.post<LoginResponse>('/auth/student-login', payload),

    studentChangePassword: (password: string) =>
        apiClient.post<{ message: string }>('/auth/student-change-password', { new_password: password }),

    profile: () =>
        apiClient.get<ProfileResponse>('/auth/profile'),

    logout: () =>
        apiClient.post<{ message: string }>('/auth/logout'),
};